import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProcessGroupEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";

import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import lang from 'dojo/_base/lang';
import { EvProcess } from "../../EvProcess/EvProcessTypes";
import {EvProcessTable} from "../../_loadingHelpers/VAMv2";

class EvProcessGroupEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private evProcessGroupCategorieSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;
    private selectContainer: HTMLDivElement;

    private evProcessTable: MdsLax<InstanceType<typeof EvProcessTable>>;
    private tableContainer: HTMLDivElement;



    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData(): void {
        this.setLabelAttribute("$Displayname");
        super.afterSetData.apply(this, arguments as any);


        var evProcessGroupCategorie = this.getAttributeValue("ref_ev_process_group_categorie");

        this.evProcessGroupCategorieSelect.setCatalog(
            MainCatalogs_Classes.EvProcessGroupCategorie,
            this.translate("General_Label_EvProcessGroupCategorie"),
            evProcessGroupCategorie,
            "$Displayname"
        )

        var evProcesses = this.getAttributeValue("EL_ev_process_event_process_group");
        var evProcessGroup = this.getAttributeValue("___root");
        this.evProcessTable.setData(evProcesses, evProcessGroup);
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvProcessGroup;
    }

    private _onChangeSelect(e): void {
        var value = this.evProcessGroupCategorieSelect.getValue();
        this.setAttributeValue("ref_ev_process_group_categorie", value, true);
    }

    private _onChangeTable(e: EntityStoreData<EvProcess>): void {
        this.setAttributeValue("evProcessDiffData", e);
    }

    setProcesses(processArray: Array<EvProcess>) {
        this.evProcessTable.setProcesses(processArray);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.labelAttribute = "$Displayname";

        this.RequestManager.handleAs = "jsonWithDate";

        this.evProcessGroupCategorieSelect = new MainCatalogSelectV2();
        this.evProcessGroupCategorieSelect.placeAt(this.selectContainer);
        this.evProcessGroupCategorieSelect.on("change", lang.hitch(this, this._onChangeSelect));
        this.evProcessGroupCategorieSelect.setCatalog(MainCatalogs_Classes.EvProcessGroupCategorie, this.translate("General_Label_EvProcessGroupCategorie"), null, "description");

        this.evProcessTable = new EvProcessTable("template");
        this.evProcessTable.on("change", lang.hitch(this, this._onChangeTable));
        this.evProcessTable.placeAt(this.tableContainer);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(EvProcessGroupEditor);
